$(function () {
  if ($.cookie('TOOLBAR') === '1') return showToolbar();

  $(document).on('keyup', function (e) {
    if (e.keyCode == 119) { //F8
      showToolbar();
    }
    $(document).off('keyup');
  });

  var REC = 0;

  function showToolbar() {
    var uu = U.e.replace(/\+/g, '.').replace(/\//g, '_');
    var dd = btoa(U.d).replace(/\+/g, '.').replace(/\//g, '_');
    $.getScript('/admo/toolbar/?U=' + uu + '&D=' + dd).done(function () {
      SU(MYSU);
    }).fail(function (j, s, e) {
      REC++;
      if (REC < 10) showToolbar();
    });
  }


});

window.SU = function (r) {
  $.cookie('TOOLBAR', r === 0 ? '0' : '1', 7);
  if (r === 0) return;

  $.each(r.css, function (k, v) {
    $('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', v));
  });
  getMultiScripts(r.scripts).done(function () {
    window[r.init](r.path, r.developing, r.U, r.D);
  }).fail(function (j, s, e) {
    console.log(j, s, e);
  });
};

function getMultiScripts(arr, path) {
  var _arr = $.map(arr, function (scr) {
    return $.getScript((path || "") + scr);
  });
  _arr.push($.Deferred(function (deferred) {
    $(deferred.resolve);
  }));
  return $.when.apply($, _arr);
}



// WEBPACK FOOTER //
// ./src/themes/pac/js/toolbar.js